export const INVOICE_STATUS_CREATED = 'CREATED'
export const INVOICE_STATUS_VIEWED = 'VIEWED'
export const INVOICE_STATUS_PARTIALLY_PAID = 'PARTIALLY_PAID'
export const INVOICE_STATUS_PAID = 'PAID'
export const INVOICE_STATUS_CANCELLED = 'CANCELLED'

export const INVOICE_TYPE_SIMPLE = "SIMPLE"
export const INVOICE_TYPE_DETAILED = "DETAILED"